import { WrapperHeader } from './PageBox.styles';
import { PageBoxIcon } from './PageBoxIcon';
import { PageBoxTitle } from './PageBoxTitle';

type PageBoxHeaderProps = {
	icon: string;
	title: string;
	alt?: string;
};

export const PageBoxHeader = ({
	icon,
	title,
	alt = title,
}: PageBoxHeaderProps): JSX.Element => (
	<WrapperHeader>
		<PageBoxIcon icon={icon} alt={alt} />
		<PageBoxTitle title={title} />
	</WrapperHeader>
);
